import type { Product } from '~/features/catalog-operations/types/catalog-operations.types';

/** Optional referrer context tagged onto product detail navigation so the detail
 *  page can render the right breadcrumb. */
export type ProductLinkContext = 'needs-attention';

/**
 * Whether a product must route to the standalone
 * `/catalog-operations/products-need-attention/{productId}` detail URL instead of
 * the batch-scoped one. True for the needs-attention listing, and for any product
 * with no batch — the batch route would otherwise interpolate an empty `$batchId`
 * and produce a broken `/catalog-operations//products/{id}` URL.
 */
export function usesNeedsAttentionDetailRoute(
  product: Pick<Product, 'batchId'>,
  context?: ProductLinkContext,
): boolean {
  return context === 'needs-attention' || product.batchId === '';
}
